import React, { useRef } from "react";
import { Tooltip as TooltipComponent } from "react-tooltip";
import { nanoid } from "nanoid";
import classNames from "classnames";
import "./style.scss";

interface Props {
  className?: string;
  children: React.ReactNode;
  content: string;
}
export const Tooltip = ({ className, children, content }: Props) => {
  const tooltipRef = useRef<HTMLDivElement>(null);
  const tooltipId = nanoid();
  return (
    <>
      <span
        ref={tooltipRef}
        className={classNames("cursor-pointer", className)}
        data-place="bottom"
        data-tooltip-id={tooltipId}
      >
        {children}
      </span>
      <TooltipComponent
        id={tooltipId}
        className="tooltip-container"
        place="bottom"
        render={() => (
          <div className="tooltip-container__content">{content}</div>
        )}
      />
    </>
  );
};
